import { updatePageIds } from "@shared/services/event_tracking/page_id_tracking";

var run = function ($rootScope, $location, C) {
  var logPageViewInHS = function () {
    var _hsq = (window._hsq = window._hsq || []);
    if ($rootScope.user) {
      _hsq.push([
        "identify",
        {
          email: $rootScope.user.email,
          id: $rootScope.user.id,
        },
      ]);
    }
    _hsq.push(["setPath", $location.url()]);
    _hsq.push(["trackPageView"]);
  };

  var logPageView = function () {
    logPageViewInHS();
  };

  var listener = $rootScope.$on("$stateChangeSuccess", function () {
    // Runs once on page load
    updatePageIds();
    logPageView();
    listener();
  });
  $rootScope.$on("$locationChangeSuccess", function () {
    // This event is triggered after a state change, but not on
    // page load
    updatePageIds();
    logPageView();
  });
};

run.$inject = ["$rootScope", "$location", "C"];

tiz.run(run);
